import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';

import { registerLicense } from '@syncfusion/ej2-base';
registerLicense('Ngo9BigBOggjHTQxAR8/V1NBaF5cXmZCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXZccnRcR2lfVkB/VkdWYUw=');



platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));
